import 'babel-polyfill';
import Vue from 'vue';
import Fragment from 'vue-fragment';
import { CollapsePlugin } from 'bootstrap-vue';  // ui plugins
import store from './store';
import App from './containers/people-profile-related-list-app.vue';

Vue.use(Fragment.Plugin);

// init ui plugins add/remove as needed
Vue.use(CollapsePlugin);

// init app
new Vue({
	store,
	components: {
		app: App
	},
}).$mount('#people-profile-related-list-app');